import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/Sidebar';
import DynamicTitle from './DynamicTitle';
import { ForceColors } from './ForceColors';
import { useSelector, useDispatch } from 'react-redux';
import { selectSidebarIsClose, selectSidebarIsMobileOpen, toggleMobileSidebar } from '../redux/sidebarSlice';
import { useState, useEffect } from 'react';

export function AuthenticatedLayout() {
    const sidebarIsClose = useSelector(selectSidebarIsClose);
    const isMobileOpen = useSelector(selectSidebarIsMobileOpen);
    const dispatch = useDispatch();
    const [isMobile, setIsMobile] = useState(false);
    
    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    
    return (
        <main className="w-full h-screen flex gap-4 relative">
            {/* Forza i colori primari e secondari */}
            <ForceColors />
            {/* Componente che aggiorna dinamicamente il titolo della pagina */}
            <DynamicTitle />
            
            {/* Mobile hamburger button */}
            {isMobile && (
                <button 
                    onClick={() => dispatch(toggleMobileSidebar())}
                    className="fixed top-4 left-4 z-50 bg-white rounded-lg shadow-lg p-3 hover:bg-gray-100 transition-colors"
                    aria-label="Toggle menu"
                >
                    <i className={`fi ${isMobileOpen ? 'fi-br-cross' : 'fi-br-menu-burger'} text-xl`}></i>
                </button>
            )}
            
            {/* Overlay for mobile */}
            {isMobile && isMobileOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-30"
                    onClick={() => dispatch(toggleMobileSidebar())}
                />
            )}
            
            {/* Sidebar */}
            <div className={`${
                isMobile 
                    ? `fixed top-0 left-0 h-full z-40 transition-transform duration-300 ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}` 
                    : 'absolute top-0 left-0 h-full z-20'
            }`}>
                <Sidebar isMobile={isMobile} />
            </div>
            
            {/* Main content */}
            <div className={`w-full transition-all duration-300 ease-in-out ${
                isMobile 
                    ? 'ml-0 px-4' 
                    : `${sidebarIsClose ? 'ml-[80px]' : 'ml-[300px]'} pl-6`
            }`}>
                <Outlet />
            </div>
        </main>
    );
}
